var render = function render(_c,_vm){return (![0, 1, false, true].includes(_vm.props.row[_vm.props.column]))?_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.props.row[_vm.props.column]))]):_c('i',{class:{
    'el-icon-check':
      [1, true].includes(_vm.props.row[_vm.props.column]) ||
      _vm.props.row[_vm.props.column] === true,
    'el-icon-close':
      [0, false].includes(_vm.props.row[_vm.props.column]) ||
      _vm.props.row[_vm.props.column] === false
  },style:({
    color: [1, true].includes(_vm.props.row[_vm.props.column]) ? 'green' : 'red'
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }